export default __webpack_public_path__ + "static/media/dog-face-gray.0d5fe8d9.svg";